import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AlertManagerState {
  shownSuccessExportIds: Record<string, boolean>;
}

const initialState: AlertManagerState = {
  shownSuccessExportIds: {},
};

const alertManagerSlice = createSlice({
  name: 'aag/alertManager',
  initialState,
  reducers: {
    markSuccessShown: (state, action: PayloadAction<string>) => {
      const exportId = action.payload;

      if (typeof exportId === 'string' && exportId.length > 0) {
        state.shownSuccessExportIds[exportId] = true;
      }
    },
    clearShown: (state) => {
      state.shownSuccessExportIds = {};
    },
  },
});

const { reducer: alertManagerReducer, actions: alertManagerActions } =
  alertManagerSlice;

export { alertManagerActions, alertManagerReducer };
